import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ApiService } from 'src/app/services/api.service';
import { ServerTypes } from 'src/app/models/servers';

export interface UploadResponse {
  mediaId: string;
}

@Injectable({
  providedIn: 'root'
})
export class FileUploadService {


  private readonly fileDataUploadEndpoint = '/Files';

  constructor(private http: HttpClient, private apiService: ApiService) { }

  private get url(): string {
    return this.apiService.getCurentServer(ServerTypes.ptdesk);
  }

public uploadFiles(files: any[], path: string ="Penalty"): Observable<any[]> {
  const headers = new HttpHeaders({
    'Content-Type': 'application/json'
  });

  // Upload each file in parallel; result order matches the input files order.
  const uploadRequests: Observable<any>[] = files.map(fileInfo => {
    const payload = {
      fileName: fileInfo.fileName,
      path: path,
      content: fileInfo.content
    };
    return this.http.post<UploadResponse>(this.url + this.fileDataUploadEndpoint, payload, { headers, observe: 'response' })
      .pipe(
        map(response => {
          if (response.status === 200) {
            return response.body?.mediaId ?? null; // Return file info if the upload is successful
          } else {
            return null; // Return null for unsuccessful uploads
          }
        }),
        catchError(error => {
          console.error(`Error uploading ${fileInfo.fileName}:`, error);
          return of(null); // Return null in case of an error
        })
      );
  });

  return forkJoin(uploadRequests);
}
}
